import styled, { css } from 'styled-components/macro';
import { RegularLinkLevel2 } from '@yme/tokens/typography';
import { ellipsisEndingLine } from '@yme/utils/styles';
const linkStyles = css `
  background: transparent;
  padding: 0;
  border: none;
`;
export const InfoLinkStyled = styled(RegularLinkLevel2) `
  ${linkStyles}
  ${ellipsisEndingLine}
`;
export const RowNameContainerStyled = styled.div `
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
